const BASE = '/ops-api';

const tokenDe = user => user?.access_token || user?.accessToken || '';

const chamar = async (method, path, user, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      api_access_token: tokenDe(user),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.erro || `HTTP ${res.status}`);
  }
  return data;
};

export const apiEstado = (accountId, user, opts = {}) =>
  chamar(
    'GET',
    `/accounts/${accountId}/estado${opts.nocache ? '?nocache=1' : ''}`,
    user
  );

export const apiConversas = (accountId, user) =>
  chamar('GET', `/accounts/${accountId}/conversas`, user);

export const apiIa = (accountId, user, ativa) =>
  chamar('POST', `/accounts/${accountId}/ia`, user, { ativa });

export const apiPausa = (accountId, user, telefone, pausar) =>
  chamar('POST', `/accounts/${accountId}/pausa`, user, { telefone, pausar });

export const apiPausaLote = (accountId, user, telefones, pausar) =>
  chamar('POST', `/accounts/${accountId}/pausa/lote`, user, { telefones, pausar });

export const apiDelay = (accountId, user, min, max) =>
  chamar('POST', `/accounts/${accountId}/delay`, user, { min, max });

export const apiFollowup = (accountId, user, payload) =>
  chamar('POST', `/accounts/${accountId}/followup`, user, payload);

export const apiNotificacao = (accountId, user, payload) =>
  chamar('POST', `/accounts/${accountId}/notificacao`, user, payload);

export const apiPrompt = (accountId, user, prompt) =>
  chamar('POST', `/accounts/${accountId}/prompt`, user, { prompt });

export const apiTreinadorAdd = (accountId, user, telefone, nome) =>
  chamar('POST', `/accounts/${accountId}/treinadores`, user, { telefone, nome });

export const apiTreinadorDel = (accountId, user, telefone) =>
  chamar('DELETE', `/accounts/${accountId}/treinadores/${telefone}`, user);

export const apiQr = (accountId, user, instance) =>
  chamar(
    'GET',
    `/accounts/${accountId}/qr${instance ? `?instance=${encodeURIComponent(instance)}` : ''}`,
    user
  );
